import React from 'react';
import { Loader } from 'react-feather';

import { KeywordListTableProps } from '../../types/keywordTypes';

const KeywordListTable: React.FC<KeywordListTableProps> = ({
  keywordGroups,
  isLoading,
  hasError,
  isEmpty,
  error,
  onGroupClick,
}) => {
  // 에러 상태
  if (hasError) {
    alert(error?.message || 'An unknown error occurred.');
    return (
      <div className="border border-x-[#DEDEDE] bg-white">
        <div className="flex h-40 items-center justify-center text-red-500">
          Failed to load keyword groups.
        </div>
      </div>
    );
  }

  // 로딩 상태
  if (isLoading) {
    return (
      <div className="border border-x-[#DEDEDE] bg-white">
        <div className="flex h-40 items-center justify-center">
          <Loader className="animate-spin text-gray-500" size={24} />
        </div>
      </div>
    );
  }

  // 빈 데이터 상태
  if (isEmpty) {
    return (
      <div className="border border-x-[#DEDEDE] bg-white">
        <div className="flex h-40 items-center justify-center text-gray-500">
          No keyword groups available.
        </div>
      </div>
    );
  }

  return (
    <div className="scrollbar-custom min-h-[calc(100vh-56px)] w-full overflow-auto border border-t-0 border-[#DEDEDE] bg-[#F1F1F1]">
      <div className="grid grid-cols-1 border-b border-[#DEDEDE] bg-[#F5F5F5] px-4 py-3">
        <div className="text-sm font-medium text-gray-700">Keyword Group</div>
      </div>

      <div className="divide-y divide-[#DEDEDE]">
        {keywordGroups.map((group) => (
          <div key={group.id} className="grid grid-cols-1 bg-white px-4 py-3">
            <button
              type="button"
              className="text-left text-sm text-[#1D1D1D] hover:underline"
              onClick={() => onGroupClick(group)}
            >
              {group.group}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default KeywordListTable;
